var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "13", height: "11", viewBox: "0 0 13 11", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.967 8.488L.992 5.52 0 6.51l3.967 3.956 8.5-8.477L11.475 1z", strokeWidth: ".5", fillRule: "evenodd" })
  );
});


// WEBPACK FOOTER //
// ./src/components/Checkmark/checkmark.svg